export const fontFamilyHeadings = ['Lexend Deca', 'Helvetica', 'sans-serif'].join(',')

export const fontFamilyPrimary = ['Nunito Sans', 'Helvetica', 'sans-serif'].join(',')

export default {
  headings: fontFamilyHeadings,
  primary: fontFamilyPrimary,
}
